<template>
  <div class="container">
    <!-- <header class="header">
      <div class="icon-back" @click="onBack()"></div>
      <div class="icon-more" @click="onMore()"></div>
      <div class="title"></div>
    </header> -->
    <main>
      <img :src="wallpaper" alt="" />
    </main>
    <div class="wallpaper-info">
      <div class="wallpaper-title"></div>
      <div class="btn-open" @click="goApp">打开APP</div>
    </div>
    <!-- <div class="wallpaper-title">{{ title }}</div>
    <div class="btn-open">APP内打开应用壁纸</div> -->
  </div>
</template>

<script>
export default {
  data: () => ({
    id: null,
    title: '',
    wallpaper: null,
    isBlur: null
  }),
  methods: {
    // onBack() {
    //   return backapp.postMessage('back')
    // },
    // onMore() {},

    goApp() {
      let url = `upupoo://openapp?action=1&id=${this.id}`
      // let url = `mobile://upupoo.com?action=1&id=${this.id}` //+ this.articleId
      this.isBlur = false
      this.clickDownload(url)
    },
    //检查app是否打开
    clickDownload(url) {
      var self = this
      // if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
      if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
        var loadDateTime = new Date()
        window.location.href = url //schema链接或者universal link
        this.loadTime = window.setTimeout(function () {
          //如果没有安装app,便会执行setTimeout跳转下载页
          var timeOutDateTime = new Date()
          if (timeOutDateTime - loadDateTime < 5000) {
            // alert('没下')
            self.$router.push({ path: '/dl' })
            // window.location = "http://www.upupoo.com"; //ios下载地址
          } else {
            window.close()
          }
        }, 1000)
      } else if (navigator.userAgent.match(/android/i)) {
        try {
          window.location.href = url //schema链接或者universal link
          // window.location.href = url
          this.loadTime = window.setTimeout(function () {
            // alert('没下')
            self.$router.push({ path: '/dl' })
            // window.location = "http://www.upupoo.com"; //android下载地址
          }, 1000)
        } catch (e) {}
      }
    },
  },
  mounted() {
    this.wallpaper = this.$route.query.src
    this.title = this.$route.query.title
    this.id = this.$route.query.id

    document.getElementsByTagName("title")[0].innerText = this.title;
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  font-family: 'Microsoft YaHei';
  position: relative;
  .header {
    position: relative;
    width: 100%;
    height: 1.12rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    .icon-back {
      position: absolute;
      left: 0.2rem;
      top: 50%;
      transform: translateY(-50%);
      width: 0.44rem;
      height: 0.44rem;
      background: url('../../assets/img/icon-close.png') no-repeat;
      background-size: contain;
    }
    .icon-more {
      position: absolute;
      right: 0.2rem;
      top: 50%;
      transform: translateY(-50%);
      width: 0.44rem;
      height: 0.44rem;
      background: url('../../assets/img/icon-more.png') no-repeat;
      background-size: contain;
    }
    .title {
      width: 2.38rem;
      height: 0.54rem;
      background: url('../../assets/img/title.png') no-repeat;
      background-size: contain;
      background-position: center;
      flex: 1;
      text-align: center;
      font-size: 0.36rem;
      color: #2c2e35;
    }
  }
  main {
    position: relative;
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
  }
  .wallpaper-info {
    position: absolute;
    left: 0;
    top: 0;
    height: .88rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.3rem;
    padding: 0 0.24rem;
    background-color: rgba(255,255,255,.9);
    .wallpaper-title {
      width: 2.36rem;
      height: 0.54rem;
      background: url('../../assets/img/title.png') no-repeat;
      background-size: contain;
      background-position: start center;
      flex: 1;
    }
    .btn-open {
      align-self: center;
      width: 1.86rem;
      height: 0.64rem;
      line-height: 0.64rem;
      color: white;
      font-size: 0.28rem;
      font-weight: bold;
      background-image: url('../../assets/img/bg-btn-2.png');
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      cursor: pointer;
      &:hover {
        filter: brightness(1.2);
      }
    }
  }
}
</style>
